import { createSlice } from "@reduxjs/toolkit";

const initialCancelConfirm = {
  isOpen: false,
  loading: false,

  // confirmation screen
  icon: "/Images/caution.png",
  title: null,
  description: null,
  confirmLabel: "Confirm",
  dismissLabel: "Not now",
  onConfirmAction: null,
  payload: null,
  // result screen
  result: null, // "success" | "error" | null
  resultIcon: null,
  resultTitle: null,
  resultMessage: null,
  okLabel: "OK",
};

const initialState = {
  cashInDataReq: [],
  cashOutDataOrder: [],
  cancelConfirm: initialCancelConfirm,
  PayloadCashInFees: null,
  PayloadCashOutFees: null,
  deliveryConfig: {},
  PayloaButlerFeesLimit: null,
  butlertabs: "Orders",
};

const CashInAndOutSlice = createSlice({
  name: "cashInAndOut",
  initialState,
  reducers: {
    // ── existing ────────────────────────────────────────────
    setCashInDataNewreq: (state, action) => {
      state.cashInDataReq = action.payload;
    },
    setCashOutDataNewOrder: (state, action) => {
      state.cashOutDataOrder = action.payload;
    },
    setCashInFeesResponse: (state, action) => {
      state.PayloadCashInFees = action.payload;
    },
    setCashOutFeesResponse: (state, action) => {
      state.PayloadCashOutFees = action.payload;
    },
    setDeliveryConfig: (state, action) => {
      state.deliveryConfig = action.payload;
    },
    setButlerFeesLimitResponse: (state, action) => {
      state.PayloaButlerFeesLimit = action.payload;
    },
    // ── cancel confirm modal ─────────────────────────────────
    openCancelConfirm: (state, action) => {
      state.cancelConfirm = {
        ...initialCancelConfirm,
        isOpen: true,
        ...action.payload,
      };
    },
    showCancelResult: (state, action) => {
      state.cancelConfirm.isOpen = true;
      state.cancelConfirm.result = action.payload.result;
      state.cancelConfirm.resultIcon = action.payload.resultIcon ?? null;
      state.cancelConfirm.resultTitle = action.payload.resultTitle ?? null;
      state.cancelConfirm.resultMessage = action.payload.resultMessage ?? null;
      state.cancelConfirm.okLabel = action.payload.okLabel ?? "OK";
      state.cancelConfirm.loading = false;
    },
    setCancelLoading: (state, action) => {
      state.cancelConfirm.loading = action.payload;
    },
    closeCancelConfirm: (state) => {
      state.cancelConfirm = initialCancelConfirm;
    },
    setButlerTabs: (state, action) => {
      state.butlertabs = action.payload;
    },
  },
});

export const {
  setCashInDataNewreq,
  setCashOutDataNewOrder,
  openCancelConfirm,
  showCancelResult,
  setCancelLoading,
  closeCancelConfirm,
  setCashInFeesResponse,
  setCashOutFeesResponse,
  setDeliveryConfig,
  setButlerFeesLimitResponse,
  setButlerTabs,
} = CashInAndOutSlice.actions;

export default CashInAndOutSlice.reducer;
